import { logError } from 'services/logging/logging';
import { GenericError } from 'support/helpers/errors/errors';

export enum ConfirmationModalIds {
  ReviewApprovalConfirmation = 'review-approval-confirmation',
  SubmitToErpConfirmation = 'submit-to-erp-confirmation',
}

const LOCAL_STORAGE_KEY = 'hidden-confirmation-modals';

export const isForeverHiddenConfirmationModal = (id: ConfirmationModalIds, userId: string) => {
  let hiddenModals = { [id]: { [userId]: false } };
  try {
    hiddenModals = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');
  } catch (error) {
    logError(
      new GenericError('Failed to parse hidden-confirmation-modals from localStorage', {
        key: LOCAL_STORAGE_KEY,
        rawValue: localStorage.getItem(LOCAL_STORAGE_KEY),
        originalError: error,
      }),
    );
  }
  return hiddenModals[id]?.[userId] === true;
};

export const setConfirmationModalHiddenForever = (id: ConfirmationModalIds, userId: string) => {
  let hiddenModals = { [id]: {} };
  try {
    hiddenModals = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');
  } catch (error) {
    logError(
      new GenericError('Failed to parse hidden-confirmation-modals from localStorage', {
        key: LOCAL_STORAGE_KEY,
        rawValue: localStorage.getItem(LOCAL_STORAGE_KEY),
        originalError: error,
      }),
    );
  }
  hiddenModals[id] = {
    ...hiddenModals[id],
    [userId]: true,
  };
  localStorage.setItem('hidden-confirmation-modals', JSON.stringify(hiddenModals));
};
